import { openDB } from 'idb'

import type { ScreenPictureDBSchema, UserScreenPictureItem } from './types'

export const screenPictureDB = openDB<ScreenPictureDBSchema>('screenPictureDB', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('pictures')) {
      db.createObjectStore('pictures', { keyPath: 'id' })
    }
  },
})

export async function savePicture(picture: UserScreenPictureItem) {
  const db = await screenPictureDB
  await db.put('pictures', picture)
}

export async function getPicture(id: string) {
  const db = await screenPictureDB
  return db.get('pictures', id)
}

export async function getPictures() {
  const db = await screenPictureDB
  return db.getAll('pictures')
}

export async function removePicture(id: string) {
  const db = await screenPictureDB
  await db.delete('pictures', id)
}

export async function clearPictures() {
  const db = await screenPictureDB
  await db.clear('pictures')
}
